import { render, staticRenderFns } from "./TravelSummary.vue?vue&type=template&id=247d457a&"
import script from "./TravelSummary.vue?vue&type=script&lang=js&"
export * from "./TravelSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports